import {styled, TableCell, Typography} from '@mui/material';

import {BasicTableRow} from '../../../../components/BasicTable/BasicTableRow';
import {EmpionButton} from '../../../../components/EmpionButton/EmpionButton';
import {transformDateWithTime} from '../../../../utils/dateUtils/dateFormattingUtils';

interface Props {
  id: string;
  batchId: string;
  createdAt: string;
  statusLabel: string;
  progressLabel: string;
  detailsLabel: string;
  onDetails: (batchId: string) => void;
  isHighlighted?: boolean;
}

const StyledCell = styled(TableCell)(() => ({
  paddingTop: '11px',
  paddingBottom: '11px',
  maxWidth: '210px',
}));

const StyledDetailsCell = styled(TableCell)(() => ({
  paddingTop: '8px',
  paddingBottom: '8px',
  maxWidth: '210px',
  textAlign: 'right',
}));

export const BatchInvitationsRow = ({
  batchId,
  createdAt,
  statusLabel,
  progressLabel,
  detailsLabel,
  onDetails,
  isHighlighted,
}: Props) => {
  return (
    <BasicTableRow
      sx={{
        backgroundColor: isHighlighted ? 'rgba(233, 143, 74, 0.15)' : 'transparent',
      }}
    >
      <StyledCell>
        <Typography variant='body1' sx={{fontSize: '14px'}}>
          {transformDateWithTime(createdAt)}
        </Typography>
      </StyledCell>
      <StyledCell>
        <Typography variant='body1' sx={{fontSize: '14px'}}>
          {statusLabel}
        </Typography>
      </StyledCell>
      <StyledCell>
        <Typography variant='body1' sx={{fontSize: '14px'}}>
          {progressLabel}
        </Typography>
      </StyledCell>
      <StyledDetailsCell>
        <EmpionButton
          onClick={() => onDetails(batchId)}
          aria-label={detailsLabel}
          sx={{minWidth: 'fit-content', height: '28px', padding: '2px 8px', marginLeft: 'auto'}}
        >
          <Typography variant='body2' sx={{color: 'white', fontWeight: 700}}>
            {detailsLabel}
          </Typography>
        </EmpionButton>
      </StyledDetailsCell>
    </BasicTableRow>
  );
};
